import { useEffect, useState } from "react";
import type { MCPConnection } from "../types";

type Props = {
  connection: Pick<
    MCPConnection,
    "name" | "icon" | "iconUrl" | "iconClassName"
  >;
  size?: "sm" | "md";
};

const SIZE_CLASS: Record<NonNullable<Props["size"]>, string> = {
  sm: "size-9 text-sm",
  md: "size-9 text-base",
};

const ConnectionIcon = ({ connection, size = "sm" }: Props) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [connection.iconUrl]);

  const showImage = Boolean(connection.iconUrl) && !imageFailed;
  const letter = connection.icon ?? connection.name.charAt(0).toUpperCase();
  const fallbackClass = connection.iconClassName ?? "bg-muted text-foreground";

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-md font-semibold ${SIZE_CLASS[size]} ${
        showImage ? "border border-border bg-white p-1.5" : fallbackClass
      }`}
    >
      {showImage ? (
        <img
          src={connection.iconUrl ?? undefined}
          alt=""
          className="size-full object-contain"
          onError={() => setImageFailed(true)}
        />
      ) : (
        letter
      )}
    </span>
  );
};

export default ConnectionIcon;
